export const SHOP_TZ = "America/Denver";

export const mtDate = (iso, opts = { month: "short", day: "numeric", year: "numeric" }) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { timeZone: SHOP_TZ, ...opts }) : "";

export const mtDateTime = (iso) =>
  iso ? `${new Date(iso).toLocaleString("en-US", { timeZone: SHOP_TZ, dateStyle: "medium", timeStyle: "short" })} MT` : "";

// Calendar day in Mountain Time, as a UTC-midnight timestamp for easy day maths.
const mtDay = (d) => {
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", { timeZone: SHOP_TZ, year: "numeric", month: "numeric", day: "numeric" })
      .formatToParts(d)
      .map((x) => [x.type, x.value])
  );
  return Date.UTC(+p.year, +p.month - 1, +p.day);
};

const weekStart = (day) => day - new Date(day).getUTCDay() * 86400000;

export const inThisWeek = (iso, now = new Date()) => weekStart(mtDay(new Date(iso))) === weekStart(mtDay(now));

export const inThisMonth = (iso, now = new Date()) => {
  const a = new Date(mtDay(new Date(iso)));
  const b = new Date(mtDay(now));
  return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth();
};
